export default "__VITE_ASSET__dd2209f9__"